const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
}

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page404: '/404',
  auth: {
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    newPassword: `${ROOTS.AUTH}/new-password`,
    verify: `${ROOTS.AUTH}/verify`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    products: `${ROOTS.DASHBOARD}/products`,
    stock: `${ROOTS.DASHBOARD}/stock`,
    reports: `${ROOTS.DASHBOARD}/reports`,
    sellerPerformance: `${ROOTS.DASHBOARD}/seller-performance`,
    productsAnalysis: `${ROOTS.DASHBOARD}/products-analysis`,
    events: {
      root: `${ROOTS.DASHBOARD}/events`,
      create: `${ROOTS.DASHBOARD}/events/create`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/events/${id}`,
      menu: (id: string) => `${ROOTS.DASHBOARD}/events/${id}?step=3`,
      ticketValidation: `${ROOTS.DASHBOARD}/events/ticket-validation`,
    },
    orders: `${ROOTS.DASHBOARD}/orders`,
    fechamento: `${ROOTS.DASHBOARD}/fechamento`,
    audit: `${ROOTS.DASHBOARD}/audit`,
    finance: `${ROOTS.DASHBOARD}/finance`,
    user: `${ROOTS.DASHBOARD}/users`,
    settings: `${ROOTS.DASHBOARD}/settings`,
    transaction: {
      root: `${ROOTS.DASHBOARD}/transaction`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/transaction/${id}`,
    },
  },
}
